import React from "react";
import { Line } from "react-chartjs-2";

const Sparkline = ({ data, color = "#00acdc", width = 80, height = 32 }) => {
  if (!data?.values || data.values.length < 2) {
    return null;
  }

  const values = data.values.filter(v => v !== null && v !== undefined);
  if (values.length < 2) {
    return null;
  }

  const chartData = {
    labels: values.map((_, i) => i),
    datasets: [{
      label: "", // avoid chart.js rendering "undefined" for an unlabeled dataset
      data: values,
      borderColor: color,
      borderWidth: 1.5,
      fill: false,
      tension: 0.3,
      pointRadius: 0,
      pointHoverRadius: 0,
    }],
  };

  // chart.js v2 option syntax (this project runs v2, not v3).
  const options = {
    responsive: false,
    maintainAspectRatio: false,
    legend: { display: false },
    tooltips: { enabled: false },
    scales: { xAxes: [{ display: false }], yAxes: [{ display: false }] },
    animation: false,
  };

  return (
    <div style={{ width, height }} className="tw-inline-block">
      <Line data={chartData} options={options} width={width} height={height} />
    </div>
  );
};

export default Sparkline;